angular.module('webcomm')
    .directive('logDisplayLink', function () {
        return {
            template: '<div class="log-display-link"><a ng-click="showLog()">Show Log</a></div>',
            replace: true,
            controller: 'LogDisplayLink'
        }
    })
    .controller('LogDisplayLink', ['$scope', function ($scope) {
        $scope.showLog = () => {
            $scope.$emit('logDisplay.show');
        }
    }]);